enum Actions {
  fetchItems = 'fetchItems',
  clearItems = 'clearItems',
}

export default Actions;
